var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{
      'aboutStyle': _vm.langVar === 'ar',
      'aboutStyle aboutStyleEn': _vm.langVar === 'en',
    }},[_c('h1',{staticClass:"whoHeader"},[_vm._v(_vm._s(_vm.$t("who")))]),_c('h6',[_vm._v("\n      "+_vm._s(_vm.$t("about1"))+"\n    ")]),_c('p',[_vm._v("\n      "+_vm._s(_vm.$t("about2"))+"\n    ")]),_c('p',[_vm._v("\n      "+_vm._s(_vm.$t("about3"))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }